import { render, staticRenderFns } from "./addTypeConfig.vue?vue&type=template&id=402f0849&scoped=true&"
import script from "./addTypeConfig.vue?vue&type=script&lang=js&"
export * from "./addTypeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f0849",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402f0849')) {
      api.createRecord('402f0849', component.options)
    } else {
      api.reload('402f0849', component.options)
    }
    module.hot.accept("./addTypeConfig.vue?vue&type=template&id=402f0849&scoped=true&", function () {
      api.rerender('402f0849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/components/addTypeConfig.vue"
export default component.exports